var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "Capa_1",
        "data-name": "Capa 1",
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "icons_antivalndalico",
            "data-name": "icons antivalndalico"
          }
        },
        [
          _c("g", [
            _c("path", {
              staticStyle: { fill: "#c4c4c4" },
              attrs: {
                d:
                  "M19.0000401,18.5000343h-.4950504v-6.7850437c0-.5949631-.4349251-1.0899668-.9999657-1.194952v-4.7700343c0-.6899896-.5600147-1.2500038-1.2500496-1.2500038h-.4999828c-.6899433,0-1.2499571.5600142-1.2499571,1.2500038v4.7500243h-.9999657v-2.0250149c0-.3900185-.1800013-.7550001-.4900246-.9900074-.3100233-.2399864-.7050209-.3199816-1.0949926-.2149963l-5.4900398,1.5950222c-.5450296.1450062-.930069.6399632-.930069,1.2099829v8.4250193h-.4999828c-.2749348,0-.4999828.2250481-.4999828.4999828,0,.2750282.2250481.4999828.4999828.4999828h14.000082c.2749348,0,.4999828-.2249546.4999828-.4999828,0-.2749348-.2250481-.4999828-.4999847-.4999828ZM15.5049992,5.7500038c0-.1399803.1100111-.2499914.2499914-.2499914h.4999838c.1400738,0,.2499924.1100111.2499924.2499914v4.7500238h-.9999657s0-4.7500238-.0000019-4.7500238ZM7.5049934,11.7200165v6.7850437h-.9999657v-8.4300451c0-.1149902.074923-.2100172.1949859-.2450123l5.4899468-1.5949755c.1050787-.0300159.1800013.0149841.2149963.0450001s.1000528.0900011.1000528.1999655v2.0250616h-3.7849607c-.6700258,0-1.2150555.5449371-1.2150555,1.214962ZM12.5050087,18.5000343h-.9999657v-1.4999485h.9999657v1.4999485ZM14.5050335,18.5000343h-.9999657v-1.4999485h.9999657v1.4999485ZM17.505024,18.5000343h-2.0000248v-2.0000248c0-.2750282-.2249556-.4999828-.4999828-.4999828h-4.0000496c-.2749348,0-.4999828.2249546-.4999828.4999828v2.0000248h-1.9999313v-6.7850437c0-.1199694.0949335-.2149963.2149963-.2149963h8.5699787c.1199703,0,.2149963.095027.2149963.2149963v6.7850437Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticStyle: { fill: "#c4c4c4" },
              attrs: {
                d:
                  "M11.9291725,12.2480135h-1.0986223c-.273632,0-.4955158.2218838-.4955158.4955158s.2218838.4955158.4955158.4955158h1.0986223c.273632,0,.4955158-.2218838.4955158-.4955158s-.2218838-.4955158-.4955158-.4955158Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticStyle: { fill: "#c4c4c4" },
              attrs: {
                d:
                  "M14.9789562,12.2480135h-1.0986223c-.273632,0-.4955158.2218838-.4955158.4955158s.2218838.4955158.4955158.4955158h1.0986223c.273632,0,.4955158-.2218838.4955158-.4955158s-.2218838-.4955158-.4955158-.4955158Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticStyle: { fill: "#c4c4c4" },
              attrs: {
                d:
                  "M11.9291725,14.154129h-1.0986223c-.273632,0-.4955158.2218838-.4955158.4955158s.2218838.4955158.4955158.4955158h1.0986223c.273632,0,.4955158-.2218838.4955158-.4955158s-.2218838-.4955158-.4955158-.4955158Z"
              }
            }),
            _vm._v(" "),
            _c("path", {
              staticStyle: { fill: "#c4c4c4" },
              attrs: {
                d:
                  "M14.9789562,14.154129h-1.0986223c-.273632,0-.4955158.2218838-.4955158.4955158s.2218838.4955158.4955158.4955158h1.0986223c.273632,0,.4955158-.2218838.4955158-.4955158s-.2218838-.4955158-.4955158-.4955158Z"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }